import Vue from "vue";
import { bus } from "@/main";
import { getMenuEntry } from "@/data/models/menu.model";

export default {
	props:[
		"black",
	],
	data() {
		return {
		}
	},
	created() {
	},
	watch: {
	},
	methods: {
	}
}


// WEBPACK FOOTER //
// ./src/components/blocks/card-block/card.block.js